import { lazy } from "react";
import i18n from "i18next";
import type { PuzzleTypeModule } from "../types";
import { registerLightsOutTranslations } from "./i18n";
import { emptyDefinition, emptyProgress, migrateProgress, serializeSubmission } from "./progress";
import { emptySolution } from "./solution";
import type {
  LightsOutDefinition,
  LightsOutProgress,
  LightsOutSolution,
  LightsOutSubmission,
} from "./types";

registerLightsOutTranslations(i18n);

export const lightsOutModule: PuzzleTypeModule<
  LightsOutDefinition,
  LightsOutSubmission,
  LightsOutProgress,
  LightsOutSolution
> = {
  key: "lights_out",
  Player: lazy(() => import("./Player")),
  Editor: lazy(() => import("./Editor")),
  SolutionEditor: lazy(() => import("./SolutionEditor")),
  PrintView: lazy(() => import("./PrintView")),
  emptyDefinition,
  emptyProgress,
  migrateProgress,
  serializeSubmission,
  emptySolution,
};
